module.exports = __webpack_public_path__ + "img/business-map-h5.20515ec1.png";